module.exports = __webpack_public_path__ + "img/US_Snare_ua.903052e5.webp";